import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { serverurl } from '../../environments/environment';
import { SnackService } from './snack.service';
import { Userdata } from '../interfaces/userdata';

@Injectable({
    providedIn: 'root'
})
export class UserdataService {
    data = new BehaviorSubject<Userdata | null>(null);

    constructor(
        private http: HttpClient,
        private snack: SnackService
    ) { }


    async showAiHintDialogValue(showAiHintDialog: boolean): Promise<boolean> {
        return await new Promise((resolve) => {
            this.http.post(serverurl + '/user/showaihintdialog', { showAiHintDialog: showAiHintDialog }).subscribe({
                next: (data: any) => {
                    let udata = this.data.getValue();
                    if (udata) {
                        udata.showAiHintDialog = showAiHintDialog;
                        this.data.next(udata);
                    }
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }
    public getUserDataByKey<K extends keyof Userdata>(key: K): Userdata[K] | null {
        const data = this.data.getValue();
        if (data) {
            return data[key];
        }
        return null;
    }

    async updateUserData(userdata: any) {
        console.log('User data updated:', userdata);

        this.data.next(userdata);
    }
    updateLicenceData(data: any): void {
        let d = this.data.getValue();
        d!.licenseData = data;
        this.data.next(d);
    }
    async updateUserDataOnServer(data: any): Promise<boolean> {
        return await new Promise((resolve) => {
            this.http.post(serverurl + '/user/data', data).subscribe({
                next: (data: any) => {
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });

    }

    async changeEmailAddress(email: string): Promise<boolean> {
        return await new Promise((resolve) => {
            this.http.post(serverurl + '/user/emailchange', { email }).subscribe({
                next: () => {
                    const user = this.data.getValue();
                    if (user) {
                        user.email = email;
                        this.data.next(user);
                    }
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }

    async uploadAvatar(avatar: any): Promise<boolean> {
        return await new Promise((resolve) => {
            let form = new FormData();
            form.append('avatar', avatar)
            this.http.post(serverurl + '/user/avatar', form).subscribe({
                next: (resdata: any) => {
                    let user = this.data.getValue();
                    user!.refreshtoken = new Date().getTime();
                    user!.avatar = 1;
                    this.data.next(user);
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }

    async deleteAvatar(): Promise<boolean> {
        return await new Promise((resolve) => {
            this.http.delete(serverurl + '/user/avatar').subscribe({
                next: () => {
                    let user = this.data.getValue();
                    if (user) {
                        user.refreshtoken = new Date().getTime();
                        user.avatar = 0;
                        this.data.next(user);
                    }
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            });
        });
    }

    public async getDefaultProjectId(): Promise<string | null> {
        let projects = this.data.getValue()?.projectData?.own;
        let defaultProjectId = await projects?.find((project: any) => project.sysDefault === 1);
        if (defaultProjectId) {
            return defaultProjectId.projectId;
        }
        return null;
    }


    checkUserBrowserLanguage(user: any): void {
        if (user.lastLogin !== undefined) {
            return;
        }

        let browserLang = navigator.language || (navigator as any).userLanguage;
        // console.log("Browserlanguage:", browserLang, "Userlanguage:", user.lang);

        if (browserLang && browserLang !== user.lang) {
            let langCode = browserLang.split("-")[0];
            user.lang = langCode;
            this.data.next(user);
            this.updateUserDataOnServer(user);
        }
    }
}
